import { i18n } from '@/main'

export class languageUtil {
  t(key) {
    return i18n.tc(key)
  }
}

export default new languageUtil()
